import React from "react";
import { MdWarning, MdDelete } from "react-icons/md";

export default function ConfirmDeleteModal({
  open,
  title = "Confirmar eliminação",
  message,
  itemName,
  loading,
  onCancel,
  onConfirm,
}) {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999,
        padding: 20,
        backdropFilter: "blur(3px)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "#fff",
          borderRadius: 20,
          padding: 28,
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        }}
      >
        <div
          style={{
            width: 70,
            height: 70,
            borderRadius: "50%",
            background: "#fee2e2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 18px auto",
          }}
        >
          <MdWarning size={38} color="#dc2626" />
        </div>

        <h2 style={{ textAlign: "center", fontSize: 22, fontWeight: 700 }}>
          {title}
        </h2>

        <p
          style={{
            textAlign: "center",
            color: "#6b7280",
            marginTop: 12,
            marginBottom: 28,
          }}
        >
          {message}{" "}
          {itemName && <strong>{itemName}</strong>}
        </p>

        <div style={{ display: "flex", gap: 12 }}>
          <button
            onClick={onCancel}
            disabled={loading}
            style={{
              flex: 1,
              height: 46,
              borderRadius: 12,
              border: "1px solid #d1d5db",
              background: "#fff",
              fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            Cancelar
          </button>

          <button
            onClick={onConfirm}
            disabled={loading}
            style={{
              flex: 1,
              height: 46,
              borderRadius: 12,
              border: "none",
              background: "#dc2626",
              color: "#fff",
              fontWeight: 600,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              opacity: loading ? 0.7 : 1,
            }}
          >
            <MdDelete size={18} />
            {loading ? "A eliminar..." : "Eliminar"}
          </button>
        </div>
      </div>
    </div>
  );
}